interface PlanNameInput {
  course: {
    name: string
  }
  additionalContents: string
  restrictions: string
}

/** プラン名を構築する */
export function planName({
  course: { name: courseName },
  additionalContents,
  restrictions,
}: PlanNameInput): string {
  let name = courseName
  if (additionalContents) {
    name += `＋${additionalContents}`
  }
  if (restrictions) {
    name += `（${restrictions}）`
  }
  return name
}

interface PlanNameInCourseInput {
  additionalContents: string
  restrictions: string
}

/** プラン選択モーダル内などコースが決まっているときに使用する「コースのみ」「コース+...」などのプラン名を構築する */
export function planNameInCourse({
  additionalContents,
  restrictions,
}: PlanNameInCourseInput): string {
  let name = 'コース'
  if (additionalContents) {
    name += `＋${additionalContents}`
  }
  if (restrictions) {
    name += `（${restrictions}）`
  }
  if (!additionalContents && !restrictions) {
    name += 'のみ'
  }
  return name
}
